// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("bs-platform/lib/js/list.js");
var $$Array = require("bs-platform/lib/js/array.js");
var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var FaIcon = require("../../shared/components/FaIcon.bs.js");
var StudentTopNav__NavLink = require("./types/StudentTopNav__Types/StudentTopNav__NavLink.bs.js");
var StudentTopNav__DropDown = require("./components/StudentTopNav__DropDown.bs.js");

((require("./StudentTopNav.css")));

function str(prim) {
  return prim;
}

function isActiveMenu(pathName) {
  var _path = window.location.pathname;
  if (pathName === _path) {
    return " active-menu-link";
  } else {
    return "";
  }
}

function headerLink(key, link) {
  return React.createElement("div", {
              key: key,
              className: "px-3 text-sm font-semibold text-center cursor-default flex md:w-auto justify-center border-r border-b md:border-0"
            }, React.createElement("a", {
                  className: "no-underline bg-gray-100 md:bg-white text-black hover:text-primary-500 w-full p-4 md:p-2 font-normal" + isActiveMenu(StudentTopNav__NavLink.url(link)),
                  href: StudentTopNav__NavLink.url(link)
                }, StudentTopNav__NavLink.title(link)));
}

function signOutLink(param) {
  return React.createElement("div", {
              key: "Logout-button",
              className: "md:ml-6 text-sm font-semibold cursor-default flex w-1/2 sm:w-1/3 md:w-auto justify-center border-r border-b md:border-0"
            }, React.createElement("div", {
                  className: "flex items-center justify-center"
                }, React.createElement("a", {
                      className: "border border-primary-500 rounded px-2 py-1 text-primary-500 text-xs md:text-sm md:leading-normal m-4 md:m-0 no-underline font-semibold text-black",
                      href: "/users/sign_out",
                      rel: "nofollow"
                    }, React.createElement(FaIcon.make, {
                          classes: "fas fa-power-off"
                        }), React.createElement("span", {
                          className: "ml-2"
                        }, "Sign Out"))));
}

function signInLink(param) {
  return React.createElement("div", undefined);
}

function isMobile(param) {
  return window.innerWidth < 768;
}

function headerFrameLinks(links) {
  var match;
  if (links) {
    var match$1 = links.tl;
    if (match$1) {
      var match$2 = match$1.tl;
      if (match$2) {
        var match$3 = match$2.tl;
        if (match$3) {
          var match$4 = match$3.tl;
          match = match$4 ? [
              {
                hd: links.hd,
                tl: {
                  hd: match$1.hd,
                  tl: {
                    hd: match$2.hd,
                    tl: /* [] */0
                  }
                }
              },
              {
                hd: match$3.hd,
                tl: {
                  hd: match$4.hd,
                  tl: match$4.tl
                }
              }
            ] : [
              links,
              /* [] */0
            ];
        } else {
          match = [
            links,
            /* [] */0
          ];
        }
      } else {
        match = [
          links,
          /* [] */0
        ];
      }
    } else {
      match = [
        links,
        /* [] */0
      ];
    }
  } else {
    match = [
      links,
      /* [] */0
    ];
  }
  return $$Array.of_list(List.append(List.mapi((function (index, l) {
                        return headerLink(String(index), l);
                      }), match[0]), {
                  hd: React.createElement(StudentTopNav__DropDown.make, {
                        links: match[1],
                        key: "more-links"
                      }),
                  tl: /* [] */0
                }));
}

function headerLinks(links, isLoggedIn) {
  var match = window.innerWidth < 768;
  var match$1;
  if (match || !links) {
    match$1 = [
      links,
      /* [] */0
    ];
  } else {
    var match$2 = links.tl;
    if (match$2) {
      var match$3 = match$2.tl;
      if (match$3) {
        var match$4 = match$3.tl;
        if (match$4) {
          var match$5 = match$4.tl;
          match$1 = match$5 ? [
              {
                hd: links.hd,
                tl: {
                  hd: match$2.hd,
                  tl: {
                    hd: match$3.hd,
                    tl: /* [] */0
                  }
                }
              },
              {
                hd: match$4.hd,
                tl: {
                  hd: match$5.hd,
                  tl: match$5.tl
                }
              }
            ] : [
              links,
              /* [] */0
            ];
        } else {
          match$1 = [
            links,
            /* [] */0
          ];
        }
      } else {
        match$1 = [
          links,
          /* [] */0
        ];
      }
    } else {
      match$1 = [
        links,
        /* [] */0
      ];
    }
  }
  return $$Array.of_list(List.append(List.append(List.mapi((function (index, l) {
                            return headerLink(String(index), l);
                          }), match$1[0]), {
                      hd: React.createElement(StudentTopNav__DropDown.make, {
                            links: match$1[1],
                            key: "more-links"
                          }),
                      tl: /* [] */0
                    }), {
                  hd: isLoggedIn ? signOutLink(undefined) : signInLink(undefined),
                  tl: /* [] */0
                }));
}

function StudentTopNav(Props) {
  var schoolName = Props.schoolName;
  var logoUrl = Props.logoUrl;
  var links = Props.links;
  var frameLinks = Props.frameLinks;
  var isLoggedIn = Props.isLoggedIn;
  var match = React.useState(function () {
        return window.innerWidth < 768;
      });
  var toggleMenuHidden = match[1];
  React.useEffect(function () {
        var resizeCB = function (param) {
          return Curry._1(toggleMenuHidden, (function (param) {
                        return window.innerWidth < 768;
                      }));
        };
        window.addEventListener("resize", resizeCB);
        
      });
  return React.createElement("div", {
              className: "border-b"
            }, React.createElement("div", {
                  className: "container mx-auto px-3 max-w-5xl"
                }, React.createElement("nav", {
                      className: "flex justify-between items-center h-20"
                    }, React.createElement("div", {
                          className: "flex w-full items-center justify-between"
                        }, window.innerWidth < 768 ? React.createElement("div", {
                                className: "student-navbar__links-container frame-links flex justify-between items-center w-full flex-no-wrap flex-shrink-0"
                              }, headerFrameLinks(frameLinks)) : null, window.innerWidth >= 768 ? React.createElement("a", {
                                className: "max-w-sm",
                                href: "/"
                              }, logoUrl !== undefined ? React.createElement("img", {
                                      className: "h-9 md:h-12 object-contain",
                                      alt: "Logo of " + schoolName,
                                      src: logoUrl
                                    }) : React.createElement("div", {
                                      className: "p-2 rounded-lg bg-white text-gray-900 hover:bg-gray-100 hover:text-primary-600"
                                    }, React.createElement("span", {
                                          className: "text-xl font-bold leading-tight"
                                        }, schoolName))) : null), !match[0] && window.innerWidth >= 768 ? React.createElement("div", {
                            className: "student-navbar__links-container flex justify-end items-center w-3/5 lg:w-3/4 flex-no-wrap flex-shrink-0"
                          }, headerLinks(links, isLoggedIn)) : null)));
}

var make = StudentTopNav;

exports.str = str;
exports.isActiveMenu = isActiveMenu;
exports.headerLink = headerLink;
exports.signOutLink = signOutLink;
exports.signInLink = signInLink;
exports.isMobile = isMobile;
exports.headerFrameLinks = headerFrameLinks;
exports.headerLinks = headerLinks;
exports.make = make;
/*  Not a pure module */
